<div class="mobile-diagnostics">
  <div class="row mb-4 align-items-center">
    <div class="col-md-6">
      <h4>{{ 'MOBILE_DIAG.TITLE' | translate }}</h4>
      <p class="text-muted">{{ 'MOBILE_DIAG.SUBTITLE' | translate }}</p>
    </div>
    <div class="col-md-6 text-end">
      <span class="text-muted me-2" *ngIf="!isLoading">
        {{ totalItems }} {{ 'MOBILE_DIAG.ENTRIES_FOUND' | translate }}
      </span>
      <button class="btn btn-outline-secondary btn-sm" (click)="loadEvents()">
        <nb-icon icon="refresh-outline"></nb-icon>
        {{ 'MOBILE_DIAG.REFRESH' | translate }}
      </button>
    </div>
  </div>

  <!-- Version adoption -->
  <nb-card class="mb-4 adoption-card">
    <nb-card-header class="d-flex justify-content-between align-items-center">
      <span>{{ 'MOBILE_DIAG.ADOPTION_TITLE' | translate }}</span>
      <span *ngIf="adoptionSource === 'fallback'" class="badge bg-secondary">
        {{ 'MOBILE_DIAG.ADOPTION_FALLBACK_BADGE' | translate:{ limit: adoptionFallbackLimit } }}
      </span>
    </nb-card-header>
    <nb-card-body>
      <div *ngIf="loadingAdoption" class="text-center py-3">
        <nb-spinner size="medium"></nb-spinner>
      </div>
      <div *ngIf="!loadingAdoption && adoptionRows.length === 0" class="text-muted small">
        {{ 'MOBILE_DIAG.ADOPTION_EMPTY' | translate }}
      </div>
      <div *ngIf="!loadingAdoption && adoptionRows.length > 0" class="table-responsive">
        <table class="table table-sm table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th>{{ 'MOBILE_DIAG.COL_APP_VERSION' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_PLATFORM' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_FLAVOR' | translate }}</th>
              <th class="text-end">{{ 'MOBILE_DIAG.COL_EVENT_COUNT' | translate }}</th>
              <th class="text-end">{{ 'MOBILE_DIAG.COL_DEVICE_COUNT' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of adoptionRows">
              <td>{{ row.appVersion }}</td>
              <td>{{ row.platform }}</td>
              <td>{{ row.flavor }}</td>
              <td class="text-end">{{ row.eventCount }}</td>
              <td class="text-end">{{ row.deviceCount }}</td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="adoptionSource === 'fallback'" class="text-muted small mt-2 mb-0">
          {{ 'MOBILE_DIAG.ADOPTION_FALLBACK_HINT' | translate:{ limit: adoptionFallbackLimit } }}
        </p>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Filters -->
  <nb-card class="mb-4">
    <nb-card-body>
      <div class="row align-items-end g-3">
        <div class="col-md-2">
          <label class="form-label">{{ 'MOBILE_DIAG.FILTER_DATE_FROM' | translate }}</label>
          <input type="date" class="form-control" [(ngModel)]="dateFrom" (change)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'MOBILE_DIAG.FILTER_DATE_TO' | translate }}</label>
          <input type="date" class="form-control" [(ngModel)]="dateTo" (change)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'MOBILE_DIAG.FILTER_APP_VERSION' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filterAppVersion"
            [placeholder]="'MOBILE_DIAG.APP_VERSION_PLACEHOLDER' | translate"
            (keyup.enter)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'MOBILE_DIAG.FILTER_PLATFORM' | translate }}</label>
          <select class="form-select" [(ngModel)]="filterPlatform" (change)="onFilterChange()">
            <option *ngFor="let opt of platformOptions" [value]="opt.value">
              {{ opt.labelKey | translate }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'MOBILE_DIAG.FILTER_FLAVOR' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filterFlavor"
            [placeholder]="'MOBILE_DIAG.FLAVOR_PLACEHOLDER' | translate"
            (keyup.enter)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'MOBILE_DIAG.FILTER_EVENT_TYPE' | translate }}</label>
          <select class="form-select" [(ngModel)]="filterEventType" (change)="onFilterChange()">
            <option *ngFor="let opt of eventTypeOptions" [value]="opt.value">
              {{ opt.labelKey | translate }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'MOBILE_DIAG.FILTER_LEVEL' | translate }}</label>
          <select class="form-select" [(ngModel)]="filterLevel" (change)="onFilterChange()">
            <option *ngFor="let opt of levelOptions" [value]="opt.value">
              {{ opt.labelKey | translate }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <button class="btn btn-outline-secondary w-100" (click)="resetFilters()">
            {{ 'MOBILE_DIAG.RESET_FILTERS' | translate }}
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Events table -->
  <nb-card>
    <nb-card-body class="p-0">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th>{{ 'MOBILE_DIAG.COL_OCCURRED_AT' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_LEVEL' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_EVENT_TYPE' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_MESSAGE' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_APP_VERSION' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_PLATFORM' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_FLAVOR' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_DEVICE' | translate }}</th>
              <th>{{ 'MOBILE_DIAG.COL_OPERATION' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let event of events; trackBy: trackByEventId">
              <td class="text-nowrap">{{ event.occurredAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>
                <span class="badge" [ngClass]="getLevelBadgeClass(event.level)">{{ event.level }}</span>
              </td>
              <td class="small">{{ event.eventType }}</td>
              <td class="message-cell small">{{ truncateMessage(event.message) }}</td>
              <td>{{ event.appVersion || '—' }}</td>
              <td>{{ event.platform || '—' }}</td>
              <td>{{ event.flavor || '—' }}</td>
              <td class="font-monospace small">{{ event.deviceId || '—' }}</td>
              <td class="small">{{ event.operation || '—' }}</td>
              <td>
                <button
                  class="btn btn-sm btn-outline-primary"
                  (click)="viewEventDetail(event)"
                  [nbTooltip]="'MOBILE_DIAG.VIEW_DETAIL' | translate">
                  <nb-icon icon="eye-outline"></nb-icon>
                  {{ 'MOBILE_DIAG.VIEW' | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="isLoading" class="text-center p-4">
        <nb-spinner size="large"></nb-spinner>
        <p class="mt-2 text-muted">{{ 'MOBILE_DIAG.LOADING' | translate }}</p>
      </div>

      <div *ngIf="!isLoading && errorMessage" class="text-center p-4">
        <nb-icon icon="alert-circle-outline" class="text-danger" style="font-size: 2rem;"></nb-icon>
        <p class="mt-2 text-danger">{{ errorMessage | translate }}</p>
        <button class="btn btn-outline-secondary btn-sm" (click)="loadEvents()">
          {{ 'MOBILE_DIAG.TRY_AGAIN' | translate }}
        </button>
      </div>

      <div *ngIf="!isLoading && !errorMessage && events.length === 0" class="text-center p-4">
        <nb-icon icon="smartphone-outline" style="font-size: 2.5rem;" class="text-muted mb-2"></nb-icon>
        <h5>{{ 'MOBILE_DIAG.NO_DATA_TITLE' | translate }}</h5>
        <p class="text-muted">{{ 'MOBILE_DIAG.NO_DATA_HINT' | translate }}</p>
      </div>

      <div
        *ngIf="!isLoading && totalPages > 1"
        class="d-flex justify-content-between align-items-center p-3 border-top">
        <div>
          <span class="text-muted">
            {{ 'MOBILE_DIAG.SHOWING' | translate }}
            {{ (currentPage - 1) * pageSize + 1 }}
            {{ 'MOBILE_DIAG.TO' | translate }}
            {{ Math.min(currentPage * pageSize, totalItems) }}
            {{ 'MOBILE_DIAG.OF' | translate }} {{ totalItems }}
          </span>
        </div>
        <div>
          <button
            class="btn btn-outline-secondary me-2"
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)">
            {{ 'MOBILE_DIAG.PREVIOUS' | translate }}
          </button>
          <span class="me-2">
            {{ 'MOBILE_DIAG.PAGE' | translate }} {{ currentPage }}
            {{ 'MOBILE_DIAG.OF' | translate }} {{ totalPages }}
          </span>
          <button
            class="btn btn-outline-secondary"
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)">
            {{ 'MOBILE_DIAG.NEXT' | translate }}
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<!-- Event detail modal -->
<nb-card *ngIf="showDetail && !showSessionTimeline" class="modal-overlay">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-3 flex-wrap">
      <h5 class="mb-0">{{ 'MOBILE_DIAG.DETAIL_TITLE' | translate }}</h5>
      <span *ngIf="selectedEvent" class="badge" [ngClass]="getLevelBadgeClass(selectedEvent.level)">
        {{ selectedEvent.level }}
      </span>
      <span *ngIf="selectedEvent?.eventType" class="badge bg-light text-dark border">
        {{ selectedEvent.eventType }}
      </span>
      <span *ngIf="selectedEvent?.occurredAt" class="text-muted small">
        {{ selectedEvent.occurredAt | date:'dd/MM/yyyy HH:mm:ss' }}
      </span>
    </div>
    <button class="btn btn-ghost" (click)="closeDetail()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body *ngIf="selectedEvent" class="modal-body">
    <div *ngIf="loadingDetail" class="text-center p-3">
      <nb-spinner size="medium"></nb-spinner>
      <p class="mt-2 text-muted small">{{ 'MOBILE_DIAG.LOADING_DETAIL' | translate }}</p>
    </div>

    <div *ngIf="!loadingDetail">
      <div class="row mb-4">
        <div class="col-md-6">
          <h6 class="section-label">{{ 'MOBILE_DIAG.DETAIL_SUMMARY' | translate }}</h6>
          <p><strong>{{ 'MOBILE_DIAG.COL_APP_VERSION' | translate }}:</strong>
            <span class="ms-2">{{ selectedEvent.appVersion || '—' }}</span>
          </p>
          <p><strong>{{ 'MOBILE_DIAG.COL_PLATFORM' | translate }}:</strong>
            <span class="ms-2">{{ selectedEvent.platform || '—' }}</span>
          </p>
          <p><strong>{{ 'MOBILE_DIAG.COL_FLAVOR' | translate }}:</strong>
            <span class="ms-2">{{ selectedEvent.flavor || '—' }}</span>
          </p>
          <p><strong>{{ 'MOBILE_DIAG.COL_DEVICE' | translate }}:</strong>
            <span class="ms-2 font-monospace small">{{ selectedEvent.deviceId || '—' }}</span>
          </p>
          <p><strong>{{ 'MOBILE_DIAG.COL_BUILD' | translate }}:</strong>
            <span class="ms-2 font-monospace small">{{ selectedEvent.buildCommit || '—' }}</span>
          </p>
        </div>
        <div class="col-md-6">
          <h6 class="section-label">{{ 'MOBILE_DIAG.DETAIL_SESSION' | translate }}</h6>
          <p><strong>{{ 'MOBILE_DIAG.SESSION_ID' | translate }}:</strong>
            <span class="ms-2 font-monospace small">{{ selectedEvent.diagnosticSessionId || '—' }}</span>
          </p>
          <p *ngIf="selectedEvent.operation"><strong>{{ 'MOBILE_DIAG.COL_OPERATION' | translate }}:</strong>
            <span class="ms-2">{{ selectedEvent.operation }}</span>
          </p>
          <p *ngIf="selectedEvent.elapsedMs != null"><strong>{{ 'MOBILE_DIAG.ELAPSED_MS' | translate }}:</strong>
            <span class="ms-2">{{ selectedEvent.elapsedMs }}</span>
          </p>
          <button
            *ngIf="selectedEvent.diagnosticSessionId"
            class="btn btn-outline-primary btn-sm mt-2"
            (click)="viewSessionTimeline()">
            <nb-icon icon="clock-outline"></nb-icon>
            {{ 'MOBILE_DIAG.VIEW_SESSION' | translate }}
          </button>
        </div>
      </div>

      <h6 class="section-label">{{ 'MOBILE_DIAG.MESSAGE' | translate }}</h6>
      <pre class="json-block message-block">{{ selectedEvent.message || '—' }}</pre>

      <h6 class="section-label mt-3">{{ 'MOBILE_DIAG.STACK' | translate }}</h6>
      <pre class="json-block stack-block">{{ selectedEvent.stack || '—' }}</pre>

      <h6 class="section-label mt-3">{{ 'MOBILE_DIAG.BREADCRUMBS' | translate }}</h6>
      <pre class="json-block">{{ prettyJson(selectedEvent.breadcrumbs) }}</pre>

      <h6 class="section-label mt-3">{{ 'MOBILE_DIAG.CONTEXT' | translate }}</h6>
      <pre class="json-block">{{ prettyJson(selectedEvent.context) }}</pre>

      <div *ngIf="selectedEvent.logTail?.length">
        <h6 class="section-label mt-3">{{ 'MOBILE_DIAG.LOG_TAIL' | translate }}</h6>
        <pre class="json-block">{{ prettyJson(selectedEvent.logTail) }}</pre>
      </div>

      <div *ngIf="selectedEvent.perf">
        <h6 class="section-label mt-3">{{ 'MOBILE_DIAG.PERF' | translate }}</h6>
        <pre class="json-block">{{ prettyJson(selectedEvent.perf) }}</pre>
      </div>
    </div>
  </nb-card-body>
</nb-card>

<!-- Session timeline modal -->
<nb-card *ngIf="showSessionTimeline" class="modal-overlay modal-wide">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <div>
      <h5 class="mb-0">{{ 'MOBILE_DIAG.SESSION_TITLE' | translate }}</h5>
      <p class="text-muted small mb-0 font-monospace">{{ sessionId }}</p>
    </div>
    <button class="btn btn-ghost" (click)="closeSessionTimeline()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body class="modal-body">
    <div *ngIf="loadingSession" class="text-center p-3">
      <nb-spinner size="medium"></nb-spinner>
    </div>

    <div *ngIf="!loadingSession && sessionTimeline.length === 0" class="text-muted">
      {{ 'MOBILE_DIAG.SESSION_EMPTY' | translate }}
    </div>

    <div *ngIf="!loadingSession && sessionTimeline.length > 0" class="table-responsive">
      <table class="table table-sm table-hover">
        <thead class="table-light">
          <tr>
            <th>{{ 'MOBILE_DIAG.COL_OCCURRED_AT' | translate }}</th>
            <th>{{ 'MOBILE_DIAG.COL_LEVEL' | translate }}</th>
            <th>{{ 'MOBILE_DIAG.COL_EVENT_TYPE' | translate }}</th>
            <th>{{ 'MOBILE_DIAG.COL_MESSAGE' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let evt of sessionTimeline; trackBy: trackByEventId">
            <td class="text-nowrap">{{ evt.occurredAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td>
              <span class="badge" [ngClass]="getLevelBadgeClass(evt.level)">{{ evt.level }}</span>
            </td>
            <td class="small">{{ evt.eventType }}</td>
            <td class="small">{{ truncateMessage(evt.message, 120) }}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary" (click)="openTimelineEvent(evt)">
                {{ 'MOBILE_DIAG.VIEW' | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </nb-card-body>
</nb-card>
